import { t } from '../../plugins/i18n.js';
export const taxExclusions = [
  {
    country: 'Armenia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'AM',
  },
  {
    country: 'Australia',
    text: t('fbc.common.excluding_tax.gst_tip'),
    id: 'AU',
  },
  {
    country: 'Austria',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'AT',
  },
  {
    country: 'Bahrain',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BH',
  },
  {
    country: 'Barbados',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BB',
  },
  {
    country: 'Bangladesh',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BD',
  },
  {
    country: 'Belarus',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BY',
  },
  {
    country: 'Belgium',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BE',
  },
  {
    country: 'Bulgaria',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'BG',
  },
  {
    country: 'Cambodia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'KH',
  },
  {
    country: 'Cameroon',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'CM',
  },
  {
    country: 'Canary Islands',
    text: t('fbc.common.excluding_tax.igic_tip'),
    id: 'IC',
  },
  {
    country: 'Chile',
    text: t('fbc.common.excluding_tax.iva_tip'),
    id: 'CL',
  },
  {
    country: 'Colombia',
    text: t('fbc.common.excluding_tax.iva_tip'),
    id: 'CO',
  },
  {
    country: 'Croatia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'HR',
  },
  {
    country: 'Cyprus',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'CY',
  },
  {
    country: 'Czech Republic',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'CZ',
  },
  {
    country: 'Denmark',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'DK',
  },
  {
    country: 'Egypt',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'EG',
  },
  {
    country: 'Estonia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'EE',
  },
  {
    country: 'Finland',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'FI',
  },
  {
    country: 'France',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'FR',
  },
  {
    country: 'Georgia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'GE',
  },
  {
    country: 'Greece',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'GR',
  },
  {
    country: 'Hungary',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'HU',
  },
  {
    country: 'Iceland',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'IS',
  },
  {
    country: 'India',
    text: t('fbc.common.excluding_tax.gst_tip'),
    id: 'IN',
  },
  {
    country: 'Indonesia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'ID',
  },
  {
    country: 'Ireland',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'IE',
  },
  {
    country: 'Isle of Man',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'IM',
  },
  {
    country: 'Italy',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'IT',
  },
  {
    country: 'Japan',
    text: t('fbc.common.excluding_tax.jct_tip'),
    id: 'JP',
  },
  {
    country: 'Kazakhstan',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'KZ',
  },
  {
    country: 'Kenya',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'KE',
  },
  {
    country: 'Latvia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'LV',
  },
  {
    country: 'Liechtenstein',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'LI',
  },
  {
    country: 'Lithuania',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'LT',
  },
  {
    country: 'Luxembourg',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'LU',
  },
  {
    country: 'Malaysia',
    text: t('fbc.common.excluding_tax.stods_tip'),
    id: 'MY',
  },
  {
    country: 'Malta',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'MT',
  },
  {
    country: 'Mexico',
    text: t('fbc.common.excluding_tax.iva_tip'),
    id: 'MX',
  },
  {
    country: 'Moldova',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'MD',
  },
  {
    country: 'Monaco',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'MC',
  },
  {
    country: 'Nigeria',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'NG',
  },
  {
    country: 'Norway',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'NO',
  },
  {
    country: 'Oman',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'OM',
  },
  {
    country: 'Poland',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'PL',
  },
  {
    country: 'Portugal',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'PT',
  },
  {
    country: 'Romania',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'RO',
  },
  {
    country: 'Russia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'RU',
  },
  {
    country: 'Saudi Arabia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'SA',
  },
  {
    country: 'Senegal',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'SN',
  },
  {
    country: 'Singapore',
    text: t('fbc.common.excluding_tax.gst_tip'),
    id: 'SG',
  },
  {
    country: 'Slovakia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'SK',
  },
  {
    country: 'Slovenia',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'SI',
  },
  {
    country: 'South Africa',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'ZA',
  },
  {
    country: 'South Korea',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'KR',
  },
  {
    country: 'Spain',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'ES',
  },
  {
    country: 'Sweden',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'SE',
  },
  {
    country: 'Switzerland',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'CH',
  },
  {
    country: 'Taiwan',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'TW',
  },
  {
    country: 'Tanzania',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'TZ',
  },
  {
    country: 'Thailand',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'TH',
  },
  {
    country: 'Turkey',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'TR',
  },
  {
    country: 'Uganda',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'UG',
  },
  {
    country: 'Ukraine',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'UA',
  },
  {
    country: 'United Arab Emirates',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'AE',
  },
  {
    country: 'Uzbekistan',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'UZ',
  },
  {
    country: 'Vietnam',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'VN',
  },
  {
    country: 'United Kingdom',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'GB',
  },
  {
    country: 'Germany',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'DE',
  },
  {
    country: 'New Zealand',
    text: t('fbc.common.excluding_tax.vat_tip'),
    id: 'NZ',
  },
];
